"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _GlobalLoader = _interopRequireDefault(require("../ui/GlobalLoader"));
var _config = require("../../services/config");
var _book = require("./book");
require("../../theme/fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Search = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(/* webpackChunkName: "search" */"../pages/Search"));
  });
});
var Collections = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(/* collections-page */"../pages/Collections"));
  });
});
var Offer = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(/* offer-page */"../pages/Offer"));
  });
});
var Baskets = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(/* baskets-page */"../pages/Baskets"));
  });
});
var Routes = function Routes() {
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_GlobalLoader.default, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouter.Switch, null, (0, _config.getOnGetBaskets)() && /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    component: Baskets,
    path: _book.book.carts
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    component: Collections,
    path: _book.book.collections
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    component: Offer,
    path: [_book.book.offer, _book.book.offerV2]
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    component: Offer,
    path: [_book.book.hotel]
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    exact: true,
    component: Search,
    path: _book.book.search
  })));
};
var _default = exports.default = Routes;